/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ResendInvitationMutationResponse,
  ResendInvitationPathParams,
  ResendInvitation400,
} from '../types/ResendInvitation'

function getResendInvitationUrl({
  id,
}: {
  id: ResendInvitationPathParams['id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/invitations/${id}/resend/` as const,
  }
  return res
}

/**
 * @description Resend an invitation email with a new token.
 * @summary Resend an invitation email
 * {@link /api/v1/invitations/:id/resend/}
 */
export async function resendInvitation(
  { id }: { id: ResendInvitationPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ResendInvitationMutationResponse,
    ResponseErrorConfig<ResendInvitation400>,
    unknown
  >({
    method: 'POST',
    url: getResendInvitationUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
